<template>
    <div>
        <div class="form-row col-12 px-0">
            <div class="col-md-6 form-group">
                <datepicker-accessible
                    :label-single="'Od'"
                    custom-id="date-from"
                    name="date-from"
                    mode="date"
                    :use_pencil_checkbox="false"
                    :strong_label="false"
                    v-model="dateFrom"
                ></datepicker-accessible>
                <small class="text-red small-70" v-if="!validDate">
                    {{ $lang('Data musi być wcześniejsza niż data końcowa') }}
                </small>
            </div>

            <div class="col-md-6 form-group">
                <datepicker-accessible
                    :label-single="'Do'"
                    custom-id="date-to"
                    name="date-to"
                    mode="date"
                    :use_pencil_checkbox="false"
                    :strong_label="false"
                    v-model="dateTo"
                ></datepicker-accessible>
                <small class="text-red small-70" v-if="!validDate">
                    {{ $lang('Data musi być późniejsza niż data początkowa') }}
                </small>
            </div>
        </div>

        <div class="form-group">
            <label for="library_id">{{$lang('Biblioteka')}}</label>
            <select id="library_id" name="library_id" class="form-control" v-model="libraryID">
                <option :value=0>{{$lang('wybierz')}}</option>
                <option v-for="library in libraries" :value="library.id">{{library.name}}</option>
            </select>
        </div>

        <div class="form-group mb-2">
            <input type="checkbox" id="reduced" name="reduced" v-model="reduced">
            <label for="reduced">{{$lang('Wersja skrócona')}}</label>
        </div>
        <div class="form-group">
            <input type="checkbox" id="comments_for_client" name="comments_for_client" v-model="commentsForClient">
            <label for="comments_for_client">{{$lang('Komentarze dla klienta')}}</label>
        </div>
    </div>
</template>

<script>
    import ValidDate from "../../../mixins/report-valid-date";


    export default {
        name: "tasks-by-client-inputs",
        mixins: [ ValidDate],
        props: ['libraries'],
        data() {
            return {
                libraryID: 0,
                reduced: false,
                commentsForClient: false
            }
        },
        computed: {
            valid() {
                return this.dateFrom !== '-' && this.dateTo !== '-' && this.libraryID !== 0 && this.dateFrom<=this.dateTo;
            }
        },
        watch: {
            valid() {
                this.$emit('validation', this.valid);
            },
            reduced() {
                if (this.reduced) {
                    this.commentsForClient = false;
                }
            },
            commentsForClient() {
                if (this.commentsForClient) {
                    this.reduced = false;
                }
            }
        },
        created() {
            const today = new Date();
            const firstDay = new Date(today.getFullYear(), today.getMonth()-1, 1);
            const lastDay = new Date(today.getFullYear(), today.getMonth(), 0);
            this.dateFrom = firstDay.getFullYear() + '-' + ('0' + (firstDay.getMonth() + 1)).slice(-2) + '-' + ('0' + firstDay.getDate()).slice(-2);
            this.dateTo = lastDay.getFullYear() + '-' + ('0' + (lastDay.getMonth() + 1)).slice(-2) + '-' + ('0' + lastDay.getDate()).slice(-2);
        }
    }
</script>
